import {any, contains, isString} from "underscore";
import {
  getRestartRequiredMessage, isRestartRequired,
} from "~/src/pages/RexAITrustedAdvisor/Context/confirmationHelpers";

const ACTIONABLE_FAILURE_REASONS = [
  "verification_unavailable", "model_refusal", "expected_work_unproven",
  "expected_work_unavailable", "expected_work_incomplete", "expected_work_mismatch",
  "deferred_completion_unproven", "agent_work_blocked", "approval_in_progress",
  "approval_already_accepted", "approval_not_resumable", "approval_validation_failed",
  "iteration_limit",
];
const SENTENCE_END_PATTERN = /[.!?]$/;

export const isActionableStreamFailure = (payload) =>
  contains(ACTIONABLE_FAILURE_REASONS, payload.terminationReason);

const hasVisibleExplanation = (payload, explanation) => isString(explanation) &&
  any(payload.outcomeMessages, (message) => {
    const visible = message.displayContent || message.content;
    return message.role === "assistant" && isString(visible) && visible.includes(explanation);
  });

export const getStreamFailureMessage = (payload) => {
  const restartRequired = isRestartRequired(payload);
  const explanation = restartRequired ? getRestartRequiredMessage(payload) : payload.error;
  if (hasVisibleExplanation(payload, explanation)) {
    return "";
  }
  if (restartRequired || isActionableStreamFailure(payload)) {
    return explanation;
  }
  const message = isString(explanation) ? explanation.trim() : "I couldn't finish this request";
  const separator = SENTENCE_END_PATTERN.test(message) ? " " : ". ";
  const guidance = payload.retryable ?
    "Please try sending your message again." :
    "Please try again later or contact support.";
  return `${message}${separator}${guidance}`;
};
